import { ActivatedRoute } from '@angular/router';

//utility functions (not pipes)


/**
 * @param searchedParam the nome of the route parameter that you're searching
 * @param route the route object in which you want to search (will also travel to parents)
 * @returns the value of a route parameter by searching in all parents
 */
export function findInRoute(searchedParam: string, route: ActivatedRoute): string {
  let nextRouterToCheck = route;
  let res;
  while (nextRouterToCheck) {
    if (res = nextRouterToCheck.snapshot.paramMap.get(searchedParam)) {
      return res;
    }
    else {
      nextRouterToCheck = nextRouterToCheck.parent;
    }
  }

  return null;
}
/**
 * @param array the array in which we want to add a new element in a certain index
 * @param index the index at which the new element will be inserted
 * @param elementsArray an array of elements ( or a single element ) that will be inserted in the specified array position
 */
export function insertAt(array, index, ...elementsArray) {
  array.splice(index, 0, ...elementsArray);
}

export function objectEach(object, fn) {
  Object.keys(object).forEach((key) => {
    const control = object[key]
    fn(control, key)
  });
}

export function formEach(form, fn) {
  return objectEach(form.controls, fn)
}
